<template lang="html">
  <div id="app">
    <app-header v-if="isNotLogin" />
    <app-menu v-if="isNotLogin" />
    <router-view v-on:isLoading.sync="isLoading"></router-view>
    
    <loading :active.sync="isLoading" 
      :can-cancel="false" 
      :is-full-page="true"
      :z-index="9999"
      color="blue"
    ></loading>
  </div>
</template>

<script lang="js">
import "@/../assets/plugin/jquery-ui.min.js"
import { EventBus } from "./event-bus.js"

import AppHeader from '../src/components/template/header'
import AppMenu from '../src/components/template/menu'
import Loading from 'vue-loading-overlay'
export default {
  name: 'mainPage',
  data: () => ({
    isNotLogin: window.location.pathname.split('/').filter(Boolean)[0] !== 'login' && window.location.pathname.split('/').filter(Boolean)[0] !== undefined,
    isLoading: false
  }),
  components: {
    AppHeader,
    AppMenu,
    Loading
  },
  watch: {
    '$route'() {
      this.isNotLogin = window.location.pathname.split('/').filter(Boolean)[0] !== 'login' && window.location.pathname.split('/').filter(Boolean)[0] !== undefined
    }
  },
  created() {
    let vm = this

    EventBus.$on('loading', (loading) => { vm.isLoading = loading })

    vm.axios.interceptors.request.use((config) => {
      // trigger 'loading=true' event here
      const url = (config.url || '').toString()
      if (url.indexOf('/api/member/csrf') === -1 && url.indexOf('/api/member/loginCheck') === -1) {
        vm.isLoading = true
      }
      return config
    }, (error) => {
      // trigger 'loading=false' event here
      vm.isLoading = false
      return Promise.reject(error)
    })

    vm.axios.interceptors.response.use((response) => {
      // api 결과가 false고 message가 존재할 경우
      if ( !response.data.result && response.data.message ) {
        alert(response.data.message)
      }
      if ( response.data.redirect ) {
        window.location.href = response.data.redirect
      }
      // trigger 'loading=false' event here
      vm.isLoading = false
      return response
    }, (error) => {
      // trigger 'loading=false' event here
      vm.isLoading = false
      return Promise.reject(error)
    })
  }
}
</script>

<style>
	@import "../assets/css/common.css";
	@import "../assets/css/add.css";
	@import "https://code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css";
	@import '../node_modules/vue-loading-overlay/dist/vue-loading.css';
</style>
<style lang="scss">
	@import "../assets/scss/common.scss";
</style>


// WEBPACK FOOTER //
// src/App.vue